import { EntDirectoryInfoName } from "../../../models/directoryInfoName";
import { EntInitialFilterName } from "../../../models/filters/initialFilterName";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { agroApi } from "../api";
import { Paths } from "../../../paths";

export const typeEstatePurposeObjectApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getTypeEstatePurposeObjectList: builder.query<ResponseDataGet<EntDirectoryInfoName>, EntInitialFilterName>({
	  query: (filter) => ({
		url: `${ Paths.handbooks.typeestatepurposeobject }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getTypeEstatePurposeObjectById: builder.query<ResponseDataGet<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.typeestatepurposeobject }/${ id }`,
		method: 'GET',
	  }),
	}),

	addTypeEstatePurposeObject: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body) => ({
		url: `${ Paths.handbooks.typeestatepurposeobject }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editTypeEstatePurposeObject: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, EntDirectoryInfoName>({
	  query: (body) => ({
		url: `${ Paths.handbooks.typeestatepurposeobject }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteTypeEstatePurposeObject: builder.mutation<ResponseDataGet<EntDirectoryInfoName>, number>({
	  query: (id) => ({
		url: `${ Paths.handbooks.typeestatepurposeobject }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useAddTypeEstatePurposeObjectMutation,
  useDeleteTypeEstatePurposeObjectMutation,
  useEditTypeEstatePurposeObjectMutation,
  useLazyGetTypeEstatePurposeObjectListQuery
} = typeEstatePurposeObjectApi;
